<div fxLayout="column">
  <!-- IE requires all fxLayout="column" elements to have the child contents wrapped in a plain div tag -->
  <div *ngIf="isBrowserIE; else paymentAutomaticFlexColumnTemplate" [ngClass]="{ 'ie-display': isBrowserIE }">
    <ng-container *ngTemplateOutlet="paymentAutomaticFlexColumnTemplate"></ng-container>
  </div>
</div>

<ng-template #paymentAutomaticFlexColumnTemplate>
  <div fxFlex.lt-md="10px" fxFlex.gt-sm="25px">&nbsp;</div>
  <div fxFlex="100%" fxLayout="row" fxLayout.lt-md="column" fxLayoutGap.lt-md="10px">
    <div *ngIf="isBrowserIE && media.isActive('lt-md'); else paymentAutomaticMainFlexColumnTemplate">
      <ng-container *ngTemplateOutlet="paymentAutomaticMainFlexColumnTemplate"></ng-container>
    </div>
  </div>
  <div fxFlex.lt-md="10px" fxFlex.gt-sm="25px">&nbsp;</div>
</ng-template>

<ng-template #paymentAutomaticMainFlexColumnTemplate>
  <div fxFlex="5%" fxHide.lt-md></div>
  <div fxFlex="90%" fxFlex.lt-md="100%" ngStyle.lt-md="padding-left: 8px; padding-right: 8px">
    <div class="display-text normal-paragraph-spacing">
      <mat-card>
        <mat-card-content>
          <div fxLayout="column">
            <div *ngIf="isBrowserIE; else paymentAutomaticHeaderFlexColumnTemplate" [ngClass]="{ 'ie-display': isBrowserIE }">
              <ng-container *ngTemplateOutlet="paymentAutomaticHeaderFlexColumnTemplate"></ng-container>
            </div>
          </div>
          <div fxLayout="column">
            <div *ngIf="isBrowserIE; else paymentAutomaticStepperFlexColumnTemplate" [ngClass]="{ 'ie-display': isBrowserIE }">
              <ng-container *ngTemplateOutlet="paymentAutomaticStepperFlexColumnTemplate"></ng-container>
            </div>
          </div>
        </mat-card-content>
      </mat-card>
    </div>
  </div>
  <div fxFlex="5%" fxHide.lt-md></div>
</ng-template>

<ng-template #paymentAutomaticHeaderFlexColumnTemplate>
  <div fxLayout="column">
    <div class="display-text primary-dark-color-important" *ngIf="userFullName.length > 0">
      <span style="white-space: nowrap !important;" fxLayoutAlign="start center">
        <b>{{ userFullName }}</b>
      </span>
    </div>
    <div class="display-text primary-dark-color-important">
      <b
        ><span i18n="@@payment-automatic.header.participant-id.label">payment-automatic.header.participant-id.label</span>:&nbsp;{{
          participantIdString
        }}</b
      >
    </div>
    <div class="border-bottom-blue" style="margin-top: 16px"></div>
  </div>
</ng-template>

<ng-template #paymentAutomaticStepperFlexColumnTemplate>
  <mat-vertical-stepper [linear]="true" #paymentAutomaticStepper>
    <ng-template matStepperIcon="edit"> <mat-icon>done</mat-icon> </ng-template>
    <ng-template matStepperIcon="done"> <mat-icon>done</mat-icon> </ng-template>
    <mat-step [completed]="step1Complete" [editable]="step1Editable">
      <ng-template matStepLabel i18n="@@payment-automatic.stepper.step1.label">payment-automatic.stepper.step1.label</ng-template>
      <div class="display-text primary-dark-color-important normal-paragraph-spacing">
        <b><span i18n="@@payment-automatic.stepper.step1.title">payment-automatic.stepper.step1.title</span></b>
      </div>
      <app-payment-automatic-note-list
        [participantId]="participantId"
        [displayNotices]="true"
        (selected)="onPaymentAutomaticNoteListSelected($event)"
      ></app-payment-automatic-note-list>
    </mat-step>
    <mat-step [completed]="step2Complete" [editable]="step2Editable">
      <ng-template matStepLabel i18n="@@payment-automatic.stepper.step2.label">payment-automatic.stepper.step2.label</ng-template>
      <div class="display-text primary-dark-color-important normal-paragraph-spacing">
        <b><span i18n="@@payment-automatic.stepper.step2.title">payment-automatic.stepper.step2.title</span></b>
      </div>
      <app-payment-automatic-form
        [participantId]="participantId"
        [autoPaymentSelected]="autoPaymentSelected"
        (dataComplete)="onAutoPaymentDataComplete($event)"
        (setupAutoPayment)="onAutoPaymentSetup($event)"
        (cancelAutoPayment)="onAutoPaymentCanceled($event)"
      >
      </app-payment-automatic-form>
    </mat-step>
  </mat-vertical-stepper>
</ng-template>
